import { Component } from '@angular/core';

@Component({
  selector: 'mprd-nsp-manage-skeleton',
  templateUrl: './nsp-manage-skeleton.component.html',
})
export class NspManageSkeletonComponent {
  constructor() {}
}
